import { track } from 'utils/tracking';
import { ITrackingProductPageBaseParameters } from '../shared/baseParameters';
import { fillItems, ITrackingFillItemsParameters } from '../shared/fillItems';
import {
  fillRewardCampaign,
  ITrackingFillRewardCampaignParameters,
} from '../shared/fillRewardCampaign';

export const trackProductCardSeeAllEligibleRewards = (
  parameters: Pick<ITrackingProductPageBaseParameters, 'leadId'> &
    ITrackingFillItemsParameters &
    ITrackingFillRewardCampaignParameters,
): void => {
  const { leadId } = parameters;

  return track({
    event: 'product_interaction',
    component_type: 'card',
    component_title: 'Reward Card_See All Eligible Rewards',
    action: 'click',
    item_list_name: 'apply form',
    ...fillItems(parameters),
    step_number: '1',
    step_name: 'lead-submission',
    lead_id: leadId,
    ...fillRewardCampaign(parameters),
  });
};
